export enum EdgeAttachmentSide {
  INVALID,
  LEFT,
  RIGHT,
  TOP,
  BOTTOM,
}
